import styled from "styled-components";
import Box from "../../layout/boxes/Box/Box";

export const StyledContentBox = styled(Box)`
	position: absolute;
	padding: ${({ theme }) => theme.space.xs};
	width: 100%;
	box-sizing: border-box;
	z-index: 100;

	border-radius: ${({ theme }) => theme.radii.sm};
	box-shadow: ${({ theme }) => theme.shadows.shadow_200};

	${({ backgroundColor, theme }) => {
		switch (backgroundColor) {
			case "bg_dark":
			case "bg_dark_variant": {
				return {
					backgroundColor: theme.palette.hexForRole("bg_dark"),
				};
			}
			default: {
				return {
					backgroundColor: theme.palette.hexForRole("bg_white"),
				};
			}
		}
	}}
`;
